<template>
  <div class="about">
    <h1>首页</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: {},
      title: {},
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
  },
};
</script>
<style scoped>
h1 {
  text-align: center;
}
</style>